import { differenceTimeInUnits } from '@modules/Util/S/Function/util.js';
import { filter, isBoolean, join, map, pipe } from '@fxts/core';
import { zeroPad } from '../../../../../shared/util/zeroPad';

export interface ResultDiffDate {
  day: number;
  hour: number;
  minute: number;
  second: number;
}

/**
 * TODO: @shared 로 옮기기
 */
export class ProductTimeHelper {
  /**
   * from - to
   */
  public static diffDate(from: Date, to: Date): ResultDiffDate {
    return differenceTimeInUnits(['day', 'hour', 'minute', 'second'], new Date(from), new Date(to), true);
  }

  /**
   * `HH:MM:SS` 형식으로 변환해주는 함수
   */
  public static formatDiff(diff: ReturnType<typeof ProductTimeHelper.diffDate>) {
    const zeroPadTwo = zeroPad(2);

    const values: {
      value: number;
      predicate: boolean | (() => boolean);
      formatter: (value: number) => string;
    }[] = [
      { value: diff.day, predicate: () => diff.day > 0, formatter: (value) => `${value}D ` },
      { value: diff.hour, predicate: true, formatter: (value) => `${zeroPadTwo(value)}` },
      { value: diff.minute, predicate: true, formatter: (value) => `:${zeroPadTwo(value)}` },
      { value: diff.second, predicate: true, formatter: (value) => `:${zeroPadTwo(value)}` },
    ];

    return pipe(
      values,
      filter(({ predicate }) => (isBoolean(predicate) ? predicate : predicate())),
      map(({ value, formatter }) => formatter(value)),
      join(''),
    );
  }
}
